// Static RICS category configuration
// These are the same 28 categories for all survey levels (1, 2, 3)
// The category code (D1, E1, etc.) is used as the primary identifier

export const SECTIONS = {
  D: { code: 'D', name: 'Outside the property', order: 1 },
  E: { code: 'E', name: 'Inside the property', order: 2 },
  F: { code: 'F', name: 'Services', order: 3 },
  G: { code: 'G', name: 'Grounds', order: 4 }
}

export const CATEGORIES = {
  // Section D - Outside the property (9 categories)
  D1: {
    code: 'D1',
    section: 'D',
    name: 'Chimney stacks',
    icon: 'factory',
    order: 1,
    aiPrompt: 'Analyse this chimney stack photo for: structural condition, pointing and mortar joints, flaunching condition, chimney pots, flashing at roof junction, any leaning or movement, weathering damage, and vegetation growth. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  D2: {
    code: 'D2',
    section: 'D',
    name: 'Roof coverings',
    icon: 'warehouse',
    order: 2,
    aiPrompt: 'Analyse this roof covering photo for: condition of tiles/slates, ridge tiles and hip tiles, any missing or slipped tiles, moss/lichen growth, sagging or dipping, flashing condition, and overall weathertightness indicators. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  D3: {
    code: 'D3',
    section: 'D',
    name: 'Rainwater pipes and gutters',
    icon: 'droplets',
    order: 3,
    aiPrompt: 'Analyse this rainwater goods photo for: gutter condition and alignment, downpipe condition, joints and brackets, signs of leaks or overflow, blockages, material type (cast iron/plastic/aluminium), and connection to drainage. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  D4: {
    code: 'D4',
    section: 'D',
    name: 'Main walls',
    icon: 'building',
    order: 4,
    aiPrompt: 'Analyse this main walls photo for: wall construction type, pointing condition, cracks (note pattern and severity), damp staining, render condition if present, movement or bulging, vegetation growth, and any structural concerns. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  D5: {
    code: 'D5',
    section: 'D',
    name: 'Windows',
    icon: 'square',
    order: 5,
    aiPrompt: 'Analyse this windows photo for: frame material and condition, glazing type (single/double), putty or seal condition, opening mechanism, paintwork/finish, condensation signs, lintels above windows, and sill condition. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  D6: {
    code: 'D6',
    section: 'D',
    name: 'Outside doors',
    icon: 'door-open',
    order: 6,
    aiPrompt: 'Analyse this outside door photo for: door material and construction, frame condition, threshold condition, weatherseals, glazing if present, hardware condition, paintwork/finish, and security features visible. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  D7: {
    code: 'D7',
    section: 'D',
    name: 'Conservatory and porches',
    icon: 'home',
    order: 7,
    aiPrompt: 'Analyse this conservatory/porch photo for: roof type and condition, frame material and condition, glazing condition, base/dwarf wall condition, junction with main building, drainage, ventilation, and any signs of leaks. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  D8: {
    code: 'D8',
    section: 'D',
    name: 'Other joinery and finishes',
    icon: 'hammer',
    order: 8,
    aiPrompt: 'Analyse this external joinery photo for: fascias and soffits condition, bargeboards, cladding if present, decorative features, paintwork condition, timber decay signs, and any necessary maintenance. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  D9: {
    code: 'D9',
    section: 'D',
    name: 'Other',
    icon: 'folder',
    order: 9,
    aiPrompt: 'Analyse this exterior photo for: any external features not covered elsewhere, balconies, external stairs, retaining walls, boundary treatments visible from exterior inspection, and general observations. Respond in 2-3 sentences focusing on condition and concerns.'
  },

  // Section E - Inside the property (9 categories)
  E1: {
    code: 'E1',
    section: 'E',
    name: 'Roof structure',
    icon: 'triangle',
    order: 10,
    aiPrompt: 'Analyse this roof structure photo for: timber condition, signs of woodworm or rot, adequate ventilation, insulation type and coverage, any modifications or reinforcements, water staining, and overall structural integrity. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  E2: {
    code: 'E2',
    section: 'E',
    name: 'Ceilings',
    icon: 'layers',
    order: 11,
    aiPrompt: 'Analyse this ceiling photo for: material type (plaster/plasterboard), cracks (note pattern), sagging or bowing, staining (water damage indicators), coving condition, and decoration condition. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  E3: {
    code: 'E3',
    section: 'E',
    name: 'Walls and partitions',
    icon: 'layout',
    order: 12,
    aiPrompt: 'Analyse this internal walls photo for: wall construction, cracking patterns, damp signs, plaster condition, decoration condition, any structural movement indicators, and partition wall stability. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  E4: {
    code: 'E4',
    section: 'E',
    name: 'Floors',
    icon: 'grid-3x3',
    order: 13,
    aiPrompt: 'Analyse this floor photo for: floor construction type, floor covering condition, any unevenness or springiness indicators, skirting boards, threshold strips, signs of damp at floor level, and overall condition. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  E5: {
    code: 'E5',
    section: 'E',
    name: 'Fireplaces, chimney breasts and flues',
    icon: 'flame',
    order: 14,
    aiPrompt: 'Analyse this fireplace photo for: fireplace type and condition, hearth condition, surround condition, chimney breast for cracks or staining, ventilation if sealed, and any signs of historic or current use. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  E6: {
    code: 'E6',
    section: 'E',
    name: 'Built-in fittings',
    icon: 'archive',
    order: 15,
    aiPrompt: 'Analyse this built-in fittings photo for: kitchen units condition, wardrobes, cupboards, worktops, hinges and handles, shelving, any signs of wear or damage, and overall quality and condition. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  E7: {
    code: 'E7',
    section: 'E',
    name: 'Woodwork',
    icon: 'door-closed',
    order: 16,
    aiPrompt: 'Analyse this woodwork photo for: internal doors condition, door frames, architraves, skirting boards, staircase (treads, risers, handrails, balusters), any timber decay or damage, and decoration condition. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  E8: {
    code: 'E8',
    section: 'E',
    name: 'Bathroom fittings',
    icon: 'bath',
    order: 17,
    aiPrompt: 'Analyse this bathroom fittings photo for: bath/shower condition, WC, basin, taps and mixers, sealant condition, tiling and grouting, ventilation, signs of leaks or water damage, and overall hygiene condition. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  E9: {
    code: 'E9',
    section: 'E',
    name: 'Other',
    icon: 'folder',
    order: 18,
    aiPrompt: 'Analyse this interior photo for: any internal features not covered elsewhere, utility rooms, en-suites, storage areas, loft conversions, basement areas, and general observations. Respond in 2-3 sentences focusing on condition and concerns.'
  },

  // Section F - Services (7 categories)
  F1: {
    code: 'F1',
    section: 'F',
    name: 'Electricity',
    icon: 'zap',
    order: 19,
    aiPrompt: 'Analyse this electrical installation photo for: consumer unit type and apparent age, circuit labelling, RCD protection visible, socket and switch condition, visible wiring condition, any obvious defects or hazards. Note: full electrical testing by qualified electrician recommended. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  F2: {
    code: 'F2',
    section: 'F',
    name: 'Gas/oil',
    icon: 'fuel',
    order: 20,
    aiPrompt: 'Analyse this gas/oil installation photo for: boiler type and apparent age, flue arrangement, meter location, visible pipework condition, ventilation provision, any obvious defects. Note: Gas Safe registered engineer inspection recommended. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  F3: {
    code: 'F3',
    section: 'F',
    name: 'Water',
    icon: 'droplet',
    order: 21,
    aiPrompt: 'Analyse this water supply photo for: stopcock location, visible pipework material and condition, storage tanks if visible, insulation provision, any signs of leaks or corrosion, and water pressure indicators. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  F4: {
    code: 'F4',
    section: 'F',
    name: 'Heating',
    icon: 'thermometer',
    order: 22,
    aiPrompt: 'Analyse this heating system photo for: radiator type and condition, pipework visible, thermostat and controls, underfloor heating indicators if present, any cold spots visible (thermal patterns), and overall system age indicators. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  F5: {
    code: 'F5',
    section: 'F',
    name: 'Water heating',
    icon: 'thermometer-sun',
    order: 23,
    aiPrompt: 'Analyse this water heating photo for: hot water cylinder type and condition, immersion heater, insulation, pipework, expansion vessel if visible, controls, and any signs of leaks or corrosion. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  F6: {
    code: 'F6',
    section: 'F',
    name: 'Drainage',
    icon: 'pipette',
    order: 24,
    aiPrompt: 'Analyse this drainage photo for: manhole covers and access points, gully condition, soil vent pipes, any visible drainage runs, signs of blockages or slow drainage, and connection type (mains/septic/cesspit indicators). Respond in 2-3 sentences focusing on condition and concerns.'
  },
  F7: {
    code: 'F7',
    section: 'F',
    name: 'Common services',
    icon: 'settings',
    order: 25,
    aiPrompt: 'Analyse this common services photo for: shared facilities if applicable (flats), communal heating, entry systems, fire safety equipment visible, and any shared maintenance responsibilities evident. Respond in 2-3 sentences focusing on condition and concerns.'
  },

  // Section G - Grounds (3 categories)
  G1: {
    code: 'G1',
    section: 'G',
    name: 'Garage',
    icon: 'car',
    order: 26,
    aiPrompt: 'Analyse this garage photo for: construction type, roof condition, door type and operation, floor condition, walls condition, electrical supply if visible, drainage, and overall structural condition. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  G2: {
    code: 'G2',
    section: 'G',
    name: 'Outbuildings and other structures',
    icon: 'warehouse',
    order: 27,
    aiPrompt: 'Analyse this outbuilding photo for: construction type, roof condition, walls condition, doors and windows, services if present, foundation/base condition, and overall structural integrity. Respond in 2-3 sentences focusing on condition and concerns.'
  },
  G3: {
    code: 'G3',
    section: 'G',
    name: 'Other',
    icon: 'trees',
    order: 28,
    aiPrompt: 'Analyse this grounds photo for: garden/plot condition, boundary walls/fences, paths and driveways, trees (proximity to building, condition), drainage, parking areas, and any ground hazards or issues. Respond in 2-3 sentences focusing on condition and concerns.'
  }
}

// Helper functions
export const getCategory = (code) => CATEGORIES[code]

export const getAllCategories = () => Object.values(CATEGORIES).sort((a, b) => a.order - b.order)

export const getCategoriesBySection = (sectionCode) => {
  return Object.values(CATEGORIES)
    .filter(cat => cat.section === sectionCode)
    .sort((a, b) => a.order - b.order)
}

export const getSectionsWithCategories = () => {
  return Object.values(SECTIONS)
    .sort((a, b) => a.order - b.order)
    .map(section => ({
      ...section,
      categories: getCategoriesBySection(section.code)
    }))
}

export const getSection = (code) => SECTIONS[code]

export default CATEGORIES
